<div class="row">
  <div class="col-xs-12 col-12">
    <pagination [totalItems]="totalItems" [(ngModel)]="currentPage"></pagination>
  </div>
</div>

<button type="button" class="btn btn-info" (click)="setPage(3)">Set current page to: 3</button>
